// extracted by mini-css-extract-plugin
module.exports = {"amazondisclaimer":"Footer_amazondisclaimer__f4Gz1"};